import { styled } from "styled-components";

export const ContractProductsRenewalOfferOptionContainer = styled.div`
  display: flex;
  gap: 4;
  flex-direction: column;
  line-height: 1.25;
`;
